var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex flex-row justify-center items-center bg-gray-100 border-2 border-gray-600 text-gray-600 rounded-xl pl-2 pr-1",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"uppercase"},[_vm._t("default")],2),_c('span',{staticClass:"close"},[_vm._v("x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }